import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingIsPerfAppSemDiscoverTreatment } from "@faire/retailer-visitor-shared/settings/useSettingPerfAppSemDiscover";
import { useSettingReviewFormGranularRatingsXP } from "@faire/retailer-visitor-shared/settings/useSettingReviewFormGranularRatingsXP";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { route as brandOrderReviewRoute } from "@faire/web-api--source/routes/www/my-reviews/brand-order/brandOrderToken";
import { useLocation } from "react-router-dom";

export const useShouldHideSearchOnMobile = ({
  isSeparateFromHeader,
}: {
  isSeparateFromHeader?: boolean;
}) => {
  const { pathname } = useLocation();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const isPerfAppSemDiscoverPageTreatment =
    useSettingIsPerfAppSemDiscoverTreatment();

  const hideSearchBarOnReviewPage =
    useSettingReviewFormGranularRatingsXP() &&
    pathMatchesRoute(pathname, brandOrderReviewRoute);

  if (
    isPerfAppSemDiscoverPageTreatment ||
    (isLoggedInRetailer && (isSeparateFromHeader || hideSearchBarOnReviewPage))
  ) {
    return true;
  }

  return false;
};
